import { CSSProperties, ComponentType, useState, FC, useContext } from 'react';

import { ICommonIconProps, Label } from '@smartshell/ui-kit';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import { LocalizationContext } from 'localization';

import s from './NavItem.module.scss';

export interface INavItemProps {
  title: string;
  to: string;
  Icon?: ComponentType<ICommonIconProps>;
  className?: string;
  collapsed?: boolean;
  style?: CSSProperties;
  disabled?: boolean;
  count?: number;
  featureDisabled?: boolean;
  isNew?: boolean;
}

export const NavItem: FC<INavItemProps> = ({
  className = '',
  style,
  collapsed = false,
  title,
  Icon,
  to,
  disabled = false,
  count,
  featureDisabled,
  isNew = false,
}) => {
  const { t } = useContext(LocalizationContext);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const [timeoutId, setTimeoutId] = useState<NodeJS.Timeout | null>(null);

  return (
    <NavLink
      onMouseEnter={() => {
        if (!collapsed) return;

        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        setIsTooltipVisible(true);
      }}
      onMouseLeave={(e) => {
        if (!collapsed) return;

        if (e.pageX < 48 || e.pageX > 53) {
          setIsTooltipVisible(false);
          return;
        }

        const timeout = setTimeout(() => setIsTooltipVisible(false), 400);
        setTimeoutId(timeout);
      }}
      className={({ isActive }) =>
        cn(
          s.root,
          className,
          disabled && s.disabled,
          !Icon && s['without-icon'],
          collapsed && s.collapsed,
          isActive && s.active
        )
      }
      to={to}
      style={style}
      {...(disabled ? { onClick: (e) => e.preventDefault() } : {})}
    >
      {collapsed && isTooltipVisible && (
        <div className={s.tooltip}>
          <span className={s['tooltip-title']}>
            {title}
            {featureDisabled && (
              <Label iconName="LockIcon" color="violet" className={s.feature} />
            )}
          </span>
        </div>
      )}
      <div className={s.left}>
        {Icon && <Icon size="m" />}
        {!collapsed && title}
      </div>
      {!collapsed && featureDisabled && (
        <Label iconName="LockIcon" color="violet" className={s.feature} />
      )}
      {isNew && (
        <Label text={t('new')} color="violetGradient" className={s.feature} />
      )}
      {Boolean(count) && <span className={cn(s.count)}>{count}</span>}
    </NavLink>
  );
};
